import { render } from "./kisHome.vue?vue&type=template&id=0a06fe08&scoped=true"
import script from "./kisHome.vue?vue&type=script&lang=js"
export * from "./kisHome.vue?vue&type=script&lang=js"

import "./kisHome.vue?vue&type=style&index=0&id=0a06fe08&scoped=true&lang=less"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a06fe08"]])

export default __exports__